import dynamic from "next/dynamic";

export const DynamicContent017 = dynamic(() => import("./Content017"), {
  suspense: true,
});
